import { Space, Table, Tag } from "antd"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { useEffect, useState } from "react"
import { db } from "../../../../firebase/config"
import { OrderAndPrefix } from "../../../Orders/Helpers/OrderAndPrefix"
import moment from "moment"

export default function StoppedOrders(props) {
  const [ordersLoading, setOrdersLoading] = useState(false)
  const [orders, setOrders] = useState([])

  //gets data from active orders for designer
  useEffect(() => {
    if (props.activeKey === 7) {
      setOrdersLoading(true)
      //ref for notifications
      const ordersRef = collection(db, "orders")

      // query
      const activeQ = query(ordersRef, where("orderStatus", "==", 999))

      //gets data with query
      const unsubscribe = onSnapshot(activeQ, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ ...doc.data(), id: doc.id })
        })

        //sets notification data
        setOrders(results)

        //removes loading
        setOrdersLoading(false)
      })
      //executes function
      return () => unsubscribe()
    }
  }, [props.activeKey])

  //default columns for table
  const defaultColumns = [
    {
      title: "Nr.",
      dataIndex: "orderNumber",
      filterTitle: "Order Number",
      key: "orderNumber",
      align: "center",
      sorter: (a, b) => a.justOrderNumber - b.justOrderNumber,
      render: (value, record) => <Space>{OrderAndPrefix(record)}</Space>,
    },
    {
      title: "Client",
      dataIndex: ["client", "client"],
      align: "center",
    },
    {
      title: "User email",
      dataIndex: "user",
      align: "center",
    },
    {
      title: "Manufacturer",
      dataIndex: ["manufacturer", "company"],
      align: "center",
    },
    {
      title: "Count",
      dataIndex: "labelCount",
      align: "center",
    },
    {
      title: "Request comment",
      dataIndex: "stopRequestComment",
      align: "center",
    },
    {
      title: "Stopped by",
      dataIndex: "stoppedBy",
      align: "center",
      render: (value) => {
        return (
          <>
            <Tag>{value}</Tag>
          </>
        )
      },
    },
    {
      title: "Stop Date",
      dataIndex: "orderStopped",
      align: "center",
      key: "created",
      filterTitle: "Creation Date",
      sorter: (a, b) => a.orderStopped.seconds - b.orderStopped.seconds,
      render: (value) => (
        <>
          <Tag color="#f5222d">{moment.unix(value.seconds).format("DD.MM.YYYY")}</Tag>
        </>
      ),
    },
  ]

  return (
    <>
      <Table
        style={{ marginTop: "15px" }}
        size="small"
        loading={ordersLoading}
        rowKey={(record) => record.id}
        columns={defaultColumns}
        dataSource={orders}
        pagination={{ defaultPageSize: "12", showSizeChanger: true }}
      />
    </>
  )
}
